import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import CloseButton from "./CloseButton";

import mq from "../../helpers/media-queries";

const El = styled.div.attrs({ className: "card" })`
  height: 100%;
  border-radius: ${rem(20)};
  width: 100%;
  background: #fff;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    height: ${rem(60)};
    background: linear-gradient(transparent, white 90%);
    z-index: 1;
    bottom: 0;

    @media screen and (max-width: 640px) {
      width: 100%;
    }

    @media screen and (min-width: 640px) {
      width: 42%;
    }
  }
`;

const CardInnerContainer = styled.div`
  height: 100%;

  ${mq("sm", "max")} {
    overflow-y: scroll;
  }

  ${mq("sm", "min")} {
    display: flex;
  }
`;

const CardImage = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${mq("sm", "max")} {
    height: 200px;
  }

  ${mq("sm", "min")} {
    width: 58%;
    height: 100%;
  }
`;

const CardText = styled.div`
  position: relative;

  ${mq("sm", "max")} {
    padding: ${rem(30)} ${rem(50)} ${rem(30)} ${rem(17.5)};
  }

  ${mq("sm", "min")} {
    width: 42%;
    overflow-y: scroll;
    padding: ${rem(60)} ${rem(35)} ${rem(55)} ${rem(35)};
  }
`;

const Subtitle = styled.h4`
  font-size: ${rem(17)};
  line-height: 1.5;
  font-family: sans-serif;
`;

const Title = styled.h2`
  font-weight: 300;
  font-size: ${rem(30)};
  line-height: 1.2;
  margin-top: ${rem(16)};
`;

const Text = styled.div`
  font-size: ${rem(15)};
  line-height: 1.5;
  color: #282a2c;
  font-family: sans-serif;
  margin-top: ${rem(16)};
  overflow-y: auto;
`;

const Card = ({ closeModal, image, title, subtitle, text }) => (
  <El>
    <CloseButton closeModal={closeModal} />

    <CardInnerContainer>
      <CardImage style={{ backgroundImage: `url(${image})` }} />

      <CardText>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}

        {title && <Title>{title}</Title>}

        {text && <Text>{text}</Text>}
      </CardText>
    </CardInnerContainer>
  </El>
);

export default Card;
